import styled from 'styled-components';
import { ScBanksLogosListWrapper } from '@/modules/promo/components/BanksLogosList/styled';
import { device } from '@/styles/helpers';

export const ScPaymentLogos = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: auto;
  align-items: center;
  z-index: 2;

  ${ScBanksLogosListWrapper} {
    display: flex;
    gap: 19px;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    z-index: 2;

    .bank {
      background-color: transparent;
      max-width: 80px;
      height: 38px;
      width: auto;
      padding: 0;
    }

    @media (${device.mobile}) {
      flex-wrap: nowrap;
      overflow-x: auto;
      justify-content: flex-start;
      padding: 8px 16px;
      gap: 16px;
      scrollbar-width: none;
      background: transparent;

      &::-webkit-scrollbar {
        display: none;
      }

      .bank {
        flex-shrink: 0;
        width: 100%;
      }
    }
  }
`;
